import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// Consts
import { AppConfig } from './../app.config';
import { Response } from './../models';
// Rxjs
import { Observable, of, throwError, TimeoutError } from 'rxjs';
import { catchError, map, retry, timeoutWith } from 'rxjs/operators';

export interface LoginAccount {
  id: string;
  password: string;
}
export interface ApiCommon {
  sql_table?: string; // Sql Table 名稱
  sql_columns?: Array<string>; // Sql 欄位名稱
  sql_value?: Array<any>; // Sql 欄位值
  sql_condition?: string; // Sql 條件
  token?: string; // Token
}
export interface ApiBlob1to1_Img {
  textObj: {},
  imageArray: File[]
}
export interface ApiBlob1to1_Img_MutipleArray {
  textCommon: {},
  textArray: any[],
  imageArray: File[]
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  
  apiTimeout: number = 60000; // 1分鐘

  constructor(
    private http: HttpClient,
  ) { }


  post(endpoint: string, value: ApiCommon): Observable<Response> {
    return this.http.post<Response>(AppConfig.apiUrl + '/api/' + endpoint, value)
      .pipe(
        retry(2), // 重新請求兩次(總共3次)
        timeoutWith(this.apiTimeout, throwError(new Error('Http Timeout exceeds'))),
        map((e: Response) => {
          return e;
        }),
        catchError(err => {
          // 備註: 補上傳送錯誤通知
          console.log('Call API failed::', err);
          if (err instanceof TimeoutError) {
            // 請求3次都失敗，總秒數大於 apiTimeout
            return of(<Response>{ // 網路連線逾時
              success: false,
              code: 112,
              data: [],
              err_custom: '',
              err_system: err,
            });
          } else {
            // 請求3次都失敗，總秒數小於 apiTimeout
            return of(<Response>{ // API請求錯誤
              success: false,
              code: 113,
              data: [],
              err_custom: '',
              err_system: err,
            });
          }
        })
      );
  }

  post_blob_1to1_img(endpoint: string, value: ApiBlob1to1_Img): Observable<Response> {
    const payload = new FormData();
    // Text Data (json data)
    const textObj = jsonToFormdataType(value.textObj);
    Object.keys(textObj).forEach(key => payload.append(key, textObj[key])); // json data
    // Image Data (file data)
    if (value.imageArray.length !== 0) { 
      value.imageArray.forEach(e => payload.append('image', e)); 
    }
    return this.http.post<Response>(AppConfig.apiUrl + '/api/' + endpoint, payload)
      .pipe(
        retry(2), // 重新請求兩次(總共3次)
        timeoutWith(this.apiTimeout, throwError(new Error('Http Timeout exceeds'))),
        map((e: Response) => {
          return e;
        }),
        catchError(err => {
          // 備註: 補上傳送錯誤通知
          console.log('Call API failed::', err);
          if (err instanceof TimeoutError) {
            // 請求3次都失敗，總秒數大於 apiTimeout
            return of(<Response>{ // 網路連線逾時
              success: false,
              code: 112,
              data: [],
              err_custom: '',
              err_system: err,
            });
          } else {
            // 請求3次都失敗，總秒數小於 apiTimeout
            return of(<Response>{ // API請求錯誤
              success: false,
              code: 113,
              data: [],
              err_custom: '',
              err_system: err,
            });
          }
        })
      );
  }

  post_blob_1to1_img_mutipleArray(endpoint: string, value: ApiBlob1to1_Img_MutipleArray): Observable<Response> {
    const payload = new FormData();
    // Text Common
    const textCommon = jsonToFormdataType(value.textCommon);
    Object.keys(textCommon).forEach(key => payload.append(key, textCommon[key])); // json data
    // Text Array (json data)
    value.textArray.forEach((e, idx) => {
      const textObj = jsonToFormdataType(e);
      Object.keys(textObj).forEach(key => {
        payload.append(`list[${idx}][${key}]`, textObj[key])
      }); // json data
    });
    // Image Data (file data)
    if (value.imageArray.length !== 0) { 
      value.imageArray.forEach(e => payload.append('image', e)); 
    }
    return this.http.post<Response>(AppConfig.apiUrl + '/api/' + endpoint, payload)
      .pipe(
        retry(2), // 重新請求兩次(總共3次)
        timeoutWith(this.apiTimeout, throwError(new Error('Http Timeout exceeds'))),
        map((e: Response) => {
          return e;
        }),
        catchError(err => {
          // 備註: 補上傳送錯誤通知
          console.log('Call API failed::', err);
          if (err instanceof TimeoutError) {
            // 請求3次都失敗，總秒數大於 apiTimeout
            return of(<Response>{ // 網路連線逾時
              success: false,
              code: 112,
              data: [],
              err_custom: '',
              err_system: err,
            });
          } else {
            // 請求3次都失敗，總秒數小於 apiTimeout
            return of(<Response>{ // API請求錯誤
              success: false,
              code: 113,
              data: [],
              err_custom: '',
              err_system: err,
            });
          }
        })
      );
  }

}


function jsonToFormdataType(json) {
  const res = {};
  Object.keys(json).forEach(key => {
    if (json[key] === null) {
      res[key] = null;
    } else {
      if (typeof json[key] === 'object') {
        const tmpJson = jsonToFormdataType(json[key]);
        Object.keys(tmpJson).forEach(k => {
          const tmpKey = key + '.' + k;
          res[tmpKey] = tmpJson[k];
        });
      } else {
        res[key] = json[key];
      }
    }
  });
  return res;
}
